export class EnvTeacherApi {
  public static defaults = 'beta';
  public static envs = {
    development: 'https://teacher-app-api.beta.saybot.net',
    beta: 'https://teacher-app-api.beta.saybot.net',
    staging: 'https://teacher-app-api.staging.saybot.net',
    production: 'https://teacher-api.alo7.com',
  };
  public static get(inKey) {
    const envs = this.envs;
    return envs[inKey] || envs[this.defaults];
  }
}
